import { render } from "./TheBreakpoints.vue?vue&type=template&id=4eb19eef"
import script from "./TheBreakpoints.vue?vue&type=script&lang=js"
export * from "./TheBreakpoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__